import { render, staticRenderFns } from "./AccessHistoryTable.vue?vue&type=template&id=07ac646b&scoped=true"
import script from "./AccessHistoryTable.vue?vue&type=script&lang=js"
export * from "./AccessHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./AccessHistoryTable.vue?vue&type=style&index=0&id=07ac646b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ac646b",
  null
  
)

export default component.exports